// @ts-nocheck


import styled from 'styled-components';

export const Wrapper = styled.div.withConfig({ displayName: "styles__Wrapper", componentId: "sc-rrp0ur-0" })(["padding:12px;"]);
